export const CREATE_SUBSCRIPTION = "v2/payment/subscription";
export const GET_PLANS = "v2/payment/products";
export const GET_CARDS = "v2/payment/cards";
export const ADD_CARD = "v2/payment/credit-card";
export const REMOVE_CARD = "v2/payment/credit-card/";
export const GET_INVOICES = "v2/payment/invoices";
export const CANCEL = "v2/payment/cancel";
export const CONSUME = "v2/payment/consume";